import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const SloveniaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_15883'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_15883)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 9.33339H20V4.66672H6.60284V3.73339C6.60284 3.73339 5.93119 3.26672 5.2381 3.26672C4.545 3.26672 3.80952 3.73339 3.80952 3.73339V4.66672H0V9.33339ZM6.19048 5.60006C6.19048 6.11552 5.76408 6.53339 5.2381 6.53339C4.71211 6.53339 4.28571 6.11552 4.28571 5.60006C4.28571 5.08459 4.71211 4.66672 5.2381 4.66672C5.76408 4.66672 6.19048 5.08459 6.19048 5.60006Z'
					fill='#0C47B7'
				/>
				<g filter='url(#filter0_d_2332_15883)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M0 14H20V9.33337H0V14Z'
						fill='#E53B35'
					/>
				</g>
			</g>
			<defs>
				<filter
					id='filter0_d_2332_15883'
					x='0'
					y='9.33337'
					width='20'
					height='4.66663'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'>
					<feFlood
						floodOpacity='0'
						result='BackgroundImageFix'
					/>
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset />
					<feColorMatrix
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0'
					/>
					<feBlend
						mode='normal'
						in2='BackgroundImageFix'
						result='effect1_dropShadow_2332_15883'
					/>
					<feBlend
						mode='normal'
						in='SourceGraphic'
						in2='effect1_dropShadow_2332_15883'
						result='shape'
					/>
				</filter>
			</defs>
		</svg>
	);
};

export default SloveniaFlagIcon;
